/// Single choke-point for Admin write-requests to `/api/*`. It reads the
/// antiforgery (CSRF) token once from the `<meta name="csrf-token">` the layout
/// renders and attaches it as the `X-CSRF-TOKEN` header on every mutating
/// request — so CSRF protection lives in ONE place instead of each of the ~13
/// scattered call sites remembering it (L-9). GET/HEAD carry no token (they are
/// not state-changing and the server only validates mutations).
///
/// Drop-in for `fetch`: same `(url, init)` shape, but it also defaults
/// `credentials: 'same-origin'` and an `Accept: application/json` header that
/// every call site previously set by hand.

const CSRF_HEADER = 'X-CSRF-TOKEN';

function csrfToken(): string {
  return document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content') ?? '';
}

export function apiFetch(url: string, init: RequestInit = {}): Promise<Response> {
  const method = (init.method ?? 'GET').toUpperCase();
  const headers = new Headers(init.headers);

  if (!headers.has('Accept')) headers.set('Accept', 'application/json');

  if (method !== 'GET' && method !== 'HEAD') {
    const token = csrfToken();
    if (token) headers.set(CSRF_HEADER, token);
  }

  return fetch(url, { credentials: 'same-origin', ...init, headers });
}
